import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import LoadingCard from 'commons/card/LoadingCard';
import * as r from 'constants/routes';
import React, {
  Fragment,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import { getSearchParams } from '../../../commons/models/params';
import GridProduct from './pages/GridProduct';
import ProductDetail from './ProductDetail';
import ProductInventory from './ProductInventory';
import { useNavigate } from 'react-router-dom';
import { useGetInventaireQuery } from '../../../redux/api/cache';

export default function ProductInfo() {
  const location = useLocation();
  const navigate = useNavigate();
  const [query, setQuery] = useState(
    `${r.INV_PREFIX_QUERY}ptr=${getSearchParams(
      'Produit',
      location.pathname
    )}&`
  );
  const [order, setOrder] = useState(undefined);

  const update = (newQuery, order) => {
    setQuery(newQuery);
    setOrder(order);
  };

  const { data, isLoading } = useGetInventaireQuery({ query: query });

  useEffect(() => {
    let num = location.pathname.split('/Produit=')[1];
    if (data?.data !== undefined) {
      let path = location.pathname.replace(
        num,
        data.data.entete[0].prod_num
      );
      navigate(path, { replace: true });
    }
  }, [data, location.pathname, order]);

  const renderSwitch = useCallback(() => {
    let params = location.pathname.split('/');
    switch (params[params.length - 1]) {
      case 'Vnl':
      case 'Cmd':
      case 'Trsf':
      case 'Liv':
      case 'Rte':
      case 'Cout':
      case 'Bin':
      case 'Stats':
      case 'Trs':
      case 'Option':
        return (
          <GridProduct
            product={data?.data?.entete[0]}
            inventory={data?.data?.entete[0]}
          />
        );
      default:
        return (
          <Fragment>
            <ProductDetail
              order={order}
              update={update}
              data={data?.data?.entete[0]}
            />
            <ProductInventory data={data?.data?.entete[0]} />
          </Fragment>
        );
    }
  }, [data?.data?.entete, location.pathname, order]);

  return (
    <div>
      {!isLoading && data?.data?.entete[0] === undefined && (
        <Card key={Math.random() + 'card'} canCollapse={false}>
          <Header title={'Oups'}></Header>
          {!isLoading && (
            <Body>
              <label> Il n'y a aucun produit associé à cet identifiant </label>
            </Body>
          )}
        </Card>
      )}
      {!isLoading && data?.data?.entete[0] !== undefined && (
        <div>{renderSwitch()}</div>
      )}
      {isLoading && <LoadingCard title="Chargement Produit..." />}
    </div>
  );
}
